"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPEECHES = [
    '孩子从不喜欢数学到喜欢，只隔了一个聪明派👍 每天放学回家都主动要求上这个课，都不用我和爸爸操心～推荐给大家！报名就送价值69元的聪明派教具，实在是太划算了！',
    '最近孩子明显对数学的概念清晰了很多，逛超市的时候还会故意提问我和爸爸😂班主任老师也很贴心，主动询问孩子的学习情况，本来很焦虑孩子喜欢掰手指，原来这是个必经阶段，现在简单的加减法孩子都能脱口而出！这个课程真的很棒，分享给有需要的爸爸妈妈们😘',
    '数学本来挺枯燥的，自己在家教孩子教不会还怕教错了，没想到聪明派光是测试题都这么好玩，孩子都玩了好几遍测试题😂根本停不下来，听老师说还有亲子模式，不但孩子喜欢，家长也能一起参与😝帮助孩子培养兴趣和学习习惯用这个app！强烈推荐！',
    '分享一下我家孩子学的一个app，【数学思维启蒙课】是根据孩子的真实水平匹配班级，学起来更有兴趣也更适合自己的孩子～拼团购买9.9，还送一套聪明派的教具盒子，非常划算😄邀请好友还能参加赢奖学金活动',
    '第一次给孩子报这种纯在app上学习的课程，使用下来比我想象的好太多。每周上4节课，两课两练，学习+练习，给孩子足够的消化和吸收时间；亲子模式+独立模式既给孩子独立思考的时间，又能陪伴孩子学习，比送辅导班要省时省力太多！价格还很划算，报名还送一套教具礼盒🎁，感兴趣的家长可以了解一下。',
    '分享一个我家孩子即将要学的数学思维课👉聪明派数学思维启蒙课,课程画面色彩丰富，动画角色生动可爱，还没上课孩子就迫不及待想玩了！学习之前老师会先让孩子做个测试题，根据测试结果来匹配对应的课程，这点很棒👍现在报名还有教具礼盒赠送，快来一起学习吧～',
];
//# sourceMappingURL=speech.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/speech.js
// module id = 1015
// module chunks = 0